import React from "react"

import { InputDigits } from "@atos6/components"
import { useStore } from "../containers"

export function InputDocumentStateful() {
  const { documentValue, documentType, setState } = useStore()
  const placeholder = documentType.toUpperCase()
  // tamanho do numero + formatação
  const maxLength = documentType === "cpf" ? 11 + 3 : 14 + 4

  return (
    <InputDigits
      placeholder={placeholder}
      maxLength={maxLength}
      value={documentValue}
      onChange={documentValue => setState({ documentValue })}
    />
  )
}
